export default __webpack_public_path__ + "static/media/gallery_20.774d85a2.jpg";